import {
    SET_APPLICATION_SETTINGS
} from './types/applicationsettings';

export function setApplicationSettings(data) {
    return {
        type: SET_APPLICATION_SETTINGS,
        payload: data
    };
}